export default [
  {
    title: "Patients",
    to: "/patients/",
    icon: "mdi-account-injury",
    group: "",
    subItems: [],
  },
  {
    title: "Calendar",
    to: "/patients/calendar/",
    icon: "mdi-checkbox-marked-outline",
  },
  {
    title: "Inspections",
    to: "/patients/inspections/",
    icon: "mdi-checkbox-marked-outline",
  },
  {
    title: "Reports",
    to: "/patients/reports/",
    icon: "mdi-checkbox-marked-outline",
  },

  {
    title: "Schedule",
    to: "/patients/schedule/",
    icon: "mdi-calendar-arrow-right",
  },
];
